import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiErr } from "@/lib/api";
import { Loading, Field } from "@/components/site/ui";

const inputCls = "w-full bg-black/30 border border-white/10 rounded-md px-3 py-2.5 text-sm text-foreground focus:border-gold focus:outline-none";

export default function PortalProfile() {
  const [g, setG] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/portal/profile").then((r) => setG(r.data || {})).catch(() => setG({})); }, []);
  const set = (k, v) => setG((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const data = {};
      ["preferred_name", "phone", "mailing_address", "birthday", "anniversary", "emergency_contact", "vehicle", "allergies", "favorite_drinks", "favorite_foods", "music_preferences", "accessibility_needs"].forEach((k) => { if (g[k] !== undefined) data[k] = g[k]; });
      await api.put("/portal/profile", { data });
      toast.success("Profile saved.");
    } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };

  if (g === null) return <Loading />;
  return (
    <div className="max-w-2xl">
      <h2 className="font-serif text-2xl mb-4">Your Profile & Preferences</h2>
      <div className="glass rounded-lg p-6 grid sm:grid-cols-2 gap-4">
        <Field label="Preferred name"><input className={inputCls} value={g.preferred_name || ""} onChange={(e) => set("preferred_name", e.target.value)} data-testid="profile-preferred" /></Field>
        <Field label="Mobile phone"><input className={inputCls} value={g.phone || ""} onChange={(e) => set("phone", e.target.value)} /></Field>
        <Field label="Mailing address"><input className={inputCls} value={g.mailing_address || ""} onChange={(e) => set("mailing_address", e.target.value)} /></Field>
        <Field label="Emergency contact"><input className={inputCls} value={g.emergency_contact || ""} onChange={(e) => set("emergency_contact", e.target.value)} /></Field>
        <Field label="Birthday"><input type="date" className={inputCls} value={g.birthday || ""} onChange={(e) => set("birthday", e.target.value)} /></Field>
        <Field label="Anniversary"><input type="date" className={inputCls} value={g.anniversary || ""} onChange={(e) => set("anniversary", e.target.value)} /></Field>
        <Field label="Vehicle & plate"><input className={inputCls} value={g.vehicle || ""} onChange={(e) => set("vehicle", e.target.value)} /></Field>
        <Field label="Allergies"><input className={inputCls} value={g.allergies || ""} onChange={(e) => set("allergies", e.target.value)} /></Field>
        <Field label="Favorite drinks"><input className={inputCls} value={g.favorite_drinks || ""} onChange={(e) => set("favorite_drinks", e.target.value)} /></Field>
        <Field label="Favorite foods"><input className={inputCls} value={g.favorite_foods || ""} onChange={(e) => set("favorite_foods", e.target.value)} /></Field>
        <Field label="Music preferences"><input className={inputCls} value={g.music_preferences || ""} onChange={(e) => set("music_preferences", e.target.value)} /></Field>
        <Field label="Accessibility needs"><input className={inputCls} value={g.accessibility_needs || ""} onChange={(e) => set("accessibility_needs", e.target.value)} /></Field>
      </div>
      <button onClick={save} disabled={saving} className="btn-gold px-7 py-3 text-sm mt-5 flex items-center gap-2" data-testid="profile-save">
        {saving ? <Loader2 className="animate-spin" size={16} /> : null} Save Profile
      </button>
    </div>
  );
}
